import { AdminPermissions } from "../../permissions/admin-permissions";
import { AuditLogPermissions } from "../../permissions/audit-log-permissions";
import { ContactManagerPermissions } from "../../permissions/contact-manager-permissions";
import { LetterManagerPermissions } from "../../permissions/letter-manager-permissions";
import { PipeLinePermissions } from "../../permissions/pipeline-permissions";
import { ReferralPermissions } from "../../permissions/referral-permissions";
import { ReportPermissions } from "../../permissions/report-permissions";
import { SchedulingPermissions } from "../../permissions/scheduling-permissions";
import { SppIndicatorManagerPermissions } from "../../permissions/spp-indicator-manager-permissions";
import { SurveyManagerPermissions } from "../../permissions/survey-manager-permissions";
import { TextBlockManagerPermissions } from "../../permissions/text-block-manager-permissions";
import { UserManagementPermissions } from "../../permissions/user-management-permissions";

export class Role {
  public constructor(init?: Partial<Role>) {
    Object.assign(this, init);
  }

  id: string;
  name: string;
  targetType: TargetUserType;
  clonedFromId?: string;
  clonedFrom: Role;
  isEditable: boolean;
  adminPermissions: AdminPermissions;
  auditLogPermissions: AuditLogPermissions;
  pipeLinePermissions: PipeLinePermissions;
  referralPermissions: ReferralPermissions;
  reportPermissions: ReportPermissions;
  schedulingPermissions: SchedulingPermissions;
  userManagementPermissions: UserManagementPermissions;
  letterManagerPermissions: LetterManagerPermissions;
  textblockManagerPermissions: TextBlockManagerPermissions;
  contactManagerPermissions: ContactManagerPermissions;
  sppIndicatorManagerPermissions: SppIndicatorManagerPermissions;
  surveyManagerPermissions: SurveyManagerPermissions;
  administrativeUnitName: string;
}

export enum TargetUserType {
  None = 0,
  System = 1,
  StateEducationAgency = 2,
  AdministrativeUnit = 3,
  District = 4,
  School = 5,
  Restricted = 6,
}

export class RoleListItem {
  name: string;
  description: string;
}
